var React = require('react');

function StepPyramid0048px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"a","d":"M15.888 20L9.325 31H39.16l-6.152-11H15.888zm1.193-2l7.644-12.813L31.891 18H17.08zM8.13 33L2.165 43h43.706L40.28 33H8.131zm37.887 12H1.961c-.789 0-1.427-.33-1.75-.906-.32-.571-.274-1.277.128-1.937L23.09 4.026C23.485 3.371 24.083 3 24.73 3c.665 0 1.27.387 1.656 1.062l21.31 38.106c.376.659.405 1.366.075 1.932-.332.572-.972.9-1.754.9z"})),React.createElement("use",{"xlinkHref":"#a","fillRule":"evenodd","key":1})]);
}

StepPyramid0048px.displayName = "StepPyramid0048px";

StepPyramid0048px.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = StepPyramid0048px;

StepPyramid0048px.default = StepPyramid0048px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/step-pyramid-00-48px.svg
// module id = 1162
// module chunks = 0